import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { TournamentsService } from './../tournaments/services/tournaments.service';
import { CoreService, CustomerUser } from '../services/core.service';
import { translationHelper } from '~/helpers/translation.helper';
declare let $;
declare let SetLanguage: any;
@Component({
    selector: 'comp_customer_transaction',
    templateUrl: './customer_transaction.html',
})
export class CustomerTransaction implements OnInit {
    dayFilter = 7;
    allbutton = 'green';
    onlymoneybutton = '';
    transactionType = -10;
    customertransactionbutton = 1;
    customerBetsDate = '7' + ' ' + this._translate.getT('Day');

    customerBetsStatus = this._translate.getT('ALL');
    sendcustomerBetsDate = '7';
    sendcustomerBetsStatus = 'All';
    constructor(
        public tournamentsService: TournamentsService,
        private coreService: CoreService,
        private _translate: translationHelper,
    ) {}
    init: boolean;
    ngOnInit() {
        if (this.init) return;
        this.init = true;
        this.tournamentsService.customertransactionButtonControl = 1;
        this.tournamentsService.customerTransactionDate = '7' + ' ' + this._translate.getT('Day');
        this.tournamentsService.getCustomerTransaction(-10, 7);
        this.tournamentsService.getCustomerBets('All', 7);
    }
    ExitDateModal() {
        $('#customertransactiondate').modal('hide');
    }
    OpenDateModal() {
        //$('#customertransactiondate').modal('show');
        $('#customertransactiondate')
            .modal({
                detachable: false,
            })
            .modal('show');
    }
    OpenBetsDateModal() {
        $('#customerbetsdate')
            .modal({
                detachable: false,
            })
            .modal('show');
    }
    ExitBetsDateModal() {
        setTimeout($('#customerbetsdate').modal('hide'), 1000);
    }
    SelectBetsState(State) {
        setTimeout($('#customerbetsstate').modal('hide'), 1000);
        this.customerBetsStatus = this._translate.getT(State);
        this.sendcustomerBetsStatus = State;
        this.tournamentsService.getCustomerBets(this.sendcustomerBetsStatus, this.sendcustomerBetsDate);
    }
    ExitBetsStateModal() {
        setTimeout($('#customerbetsstate').modal('hide'), 1000);
    }
    OpenBetsStateModal() {
        $('#customerbetsstate')
            .modal({
                detachable: false,
            })
            .modal('show');
    }
    SelectDate(Day) {
        setTimeout($('#customertransactiondate').modal('hide'), 1000);
        this.dayFilter = Day;
        if (Day == 0) {
            this.tournamentsService.customerTransactionDate = this._translate.getT('Today');
        } else {
            this.tournamentsService.customerTransactionDate = Day + ' ' + this._translate.getT('Day');
        }

        this.tournamentsService.getCustomerTransaction(this.transactionType, this.dayFilter);
    }
    SelectBetsDate(Day) {
        setTimeout($('#customerbetsdate').modal('hide'), 1000);
        this.sendcustomerBetsDate = Day;

        if (Day == 0) {
            this.customerBetsDate = this._translate.getT('Today');
        } else {
            this.customerBetsDate = Day + ' ' + this._translate.getT('Day');
        }
        this.tournamentsService.getCustomerBets(this.sendcustomerBetsStatus, this.sendcustomerBetsDate);
    }
    getAllTransaction() {
        this.allbutton = 'green';
        this.onlymoneybutton = '';
        this.transactionType = -10;
        this.tournamentsService.getCustomerTransaction(-10, this.dayFilter);
    }
    getOnlyMoneyTransaction() {
        this.allbutton = '';
        this.onlymoneybutton = 'green';
        this.transactionType = -20;
        this.tournamentsService.getCustomerTransaction(-20, this.dayFilter);
    }
    TransactionTypeSelected(TransactionType) {
        //this.customertransactionbutton = TransactionType;
        this.tournamentsService.customertransactionButtonControl = TransactionType;
        if (TransactionType == 3) {
            this.coreService.configureClient();
            $('#Customer_Keyboard_Modal')
                .modal({
                    detachable: false,
                })
                .modal('show');
        }
        //if (TransactionType == 1)
        //{
        //    this.tournamentsService.getCustomerBets("All", 7);
        //}
    }
    OpenTransactionDetail(SlipId) {
        this.tournamentsService.SlipCashOutSlipNumber = SlipId;
        this.tournamentsService.router.navigate(['/SlipDetail']);
    }
    GetBetsDetail(SlipId) {
        this.tournamentsService.SlipCashOutSlipNumber = SlipId;
        this.tournamentsService.router.navigate(['/SlipDetail']);
    }
    CustomerKeyboard_ChangeValue(e) {
        this.tournamentsService.customerPayoutPassword += e;
    }
    CustomerKeyboard_Backspace() {
        this.tournamentsService.customerPayoutPassword = this.tournamentsService.customerPayoutPassword.slice(0, -1);
    }
    CustomerKeyboard_Close() {
        setTimeout($('#Customer_Keyboard_Modal').modal('hide'), 1000);
        this.tournamentsService.customerPayoutPassword = '';
    }
    CustomerKeyboard_InputClear() {
        this.tournamentsService.customerPayoutPassword = '';
    }
    CustomerPasswordControl() {
        this.tournamentsService.CustomerPasswordControl(
            this.tournamentsService.customerPayoutPassword,
            $('input[name="__RequestVerificationToken"]').val(),
        );
    }
}
